import { LanguageCode } from "@/enums";
import { getTextResources } from "../../../tests/entities";
import { CheckoutInfo, TextResourceList } from "@/entities";
import { getTranslations, loading, replaceState, translation } from "@/utils/common";
import { defineComponent } from "vue";
import { otpStore } from "@/store";

export default defineComponent({
    name: "CompletedView",
    data: function () {
        return {
            data: new CheckoutInfo(),
            language: LanguageCode.EN,
            countryCode: "EN",
            textResourceList: new TextResourceList(),
            store: otpStore(),
        };
    },
    created() {
        replaceState();
        this.data = this.store.otp;
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            loading();
            try {
                this.textResourceList = (await this.getTextResources(this.countryCode, this.language)) as TextResourceList;
            } catch {
                return;
            } finally {
                loading();
            }
        },
        async getTextResources(countryCode: string, languageCode: LanguageCode, agent: unknown | null = null): Promise<TextResourceList | getTextResources> {
            const sysnameList = ["OtpAlreadyCompletedTitle", "OtpAlreadyCompletedSubTitle"];

            return await getTranslations(sysnameList, countryCode, languageCode, agent);
        },
        getTranslation(sysName: string, replace: string[] = []): string {
            return translation(this.textResourceList?.textResourceItems, sysName, replace);
        },
    },
});
